module.exports = __webpack_public_path__ + "static/media/mintr_362_362.fa396ba1.png";